// src/components/FounderSection.jsx
import React from 'react';
import '../styles/FounderSection.css';
import founderImg from '../Assets/Images/akij-uddin.png'; // Replace with actual image path

function FounderSection() {
  return (
    <div className="founder-section" id="founder">
      
      <div className="founder-text">
        <p className="intro">Sk. Akij Uddin</p>
        <h1 className="title">Our Honorable Founder</h1>
        <p className="statement">
          With humble beginnings and unwavering faith, we have built a legacy of trust, quality, and dedication. 
          Our foundation stands strong on the values of integrity and hard work.
        </p>
        <p className="statement">
          May the next generation continue this journey with the same passion and purpose, 
          serving the nation and beyond, In-Sha-Allah.
        </p>
      </div>
      <div className="founder-image-wrapper">
        <div className="image-circle">
          <img src={founderImg} alt="Founder Sk. Akij Uddin" className="founder-img" />
        </div>
        <div className="founder-name">
          <p><strong>Sk. Akij Uddin (1929-2006)</strong><br />Founder - Akij Group</p>
        </div>
      </div>
    </div>
  );
}

export default FounderSection;